<template>
    <div class="task">
        <div class="open-wrapper pointer" @click="openModal">
            <slot>
                <a href="javascript://void(0)">Open</a>
            </slot>
        </div>
        <modal :name=modalId
               :adaptive="true"
               :scrollable="true"
               :maxWidth="720"
               @before-close="beforeClose"
               height="auto">
            <div class="dashboard-block" :class="{loading: loading}">
                <header class="no-margin">
                    <h4 v-if="task.id" class="display-block">
                        {{task.title}}
                    </h4>
                    <h4 v-else>
                        Create Ticket<span v-if="task.taskable_type_name !== null"> for {{ task.taskable_type_name }}</span>
                    </h4>
                    <h5 v-if="task.id">
                        Ticket {{task.display_id}}&nbsp;<span v-html="task.statusLabel"></span>&nbsp;<span
                        v-html="task.archivedLabel"></span>
                    </h5>
                </header>

                <div v-if="task.id && task.labels && task.labels.length > 0" class="form-group">
                    <span class="label margin-md-right"
                          :style="{ 'background-color': label.color }"
                          v-for="label in task.labels">
                        {{label.title}}
                    </span>
                </div>

                <div class="row" v-if="task.id">
                    <div class="col-sm-6 form-group">
                        <dl class="no-margin">
                            <dt>{{task.taskable_type_name}}</dt>
                            <dd>
                                <a v-if="task.taskable_type_name !== 'Call'" :href="task.taskable_url">
                                    {{task.taskable_name}}
                                </a>
                                <div v-else>
                                    {{task.taskable_name}}
                                    <a :href="task.taskable_url">
                                        View Call
                                    </a>
                                </div>
                            </dd>

                            <dt>Resolution</dt>
                            <dd>
                                <div>
                                    <select id="task-completion-code-id"
                                            v-model="task.completion_code_id"
                                            name="Task[completion_code_id]"
                                            class="form-control">
                                        <option v-for="(completionCode) in completionCodes.filter(code => code.deleted_at === null)" :value="completionCode.id">
                                            {{completionCode.completion_message}}
                                        </option>
                                    </select>
                                </div>
                            </dd>

                            <dt>Complete</dt>
                            <dd>
                                <div class=toggle-button>
                                    <input
                                        v-model="task.completed"
                                        :disabled="task.completion_code_id === null && !task.completed"
                                        value="1"
                                        class="form-control"
                                        id="task-completed"
                                        name="Task[completed]"
                                        type="checkbox"
                                        @change="toggleTaskCompleted">

                                    <label class="control-label pointer" for="task-completed"></label>
                                </div>
                            </dd>
                            <dd v-if="task.completedBy">
                                <span>Completed By: {{task.completedBy.fullName}}</span>
                            </dd>
                        </dl>
                    </div>

                    <div class="col-sm-6 form-group" >
                        <dl class="no-margin">
                            <dt>Members</dt>
                            <dd>
                                <ul class="list-inline accesses no-margin">
                                    <li v-if="task.user"
                                        v-tooltip.top="task.user.fullName + ' (' + task.user.displayType + ')'"
                                        class="profile-icon">
                                        {{task.user.initials}} (Owner)
                                    </li>

                                    <li v-if="task.user_id === null" v-tooltip.top="'System Generated'"
                                        class="profile-icon">
                                        System
                                    </li>

                                    <li v-for="access in task.accesses"
                                        v-tooltip.top="access.user.fullName + ' (' + access.user.displayType + ')'"
                                        class="profile-icon">
                                        {{access.user.initials}}
                                    </li>
                                </ul>
                            </dd>

                            <dt v-if="displayDueAt">Due At</dt>
                            <dd v-if="displayDueAt"
                                :class="{'text-red':overdue}">
                                {{displayDueAt}} <span v-if="overdue">(Over-Due)</span>
                            </dd>
                            <dt>Claim</dt>
                            <dd>
                                <button @click="claimTicket" class="btn btn-success btn-block" :disabled="loading">Claim Ticket</button>
                            </dd>

                        </dl>
                    </div>
                </div>

                <dl v-if="task.id && task.description">
                    <dt>Description</dt>
                    <dd>
                        <div class="task-description" v-html="task.displayDescription"></div>
                    </dd>
                </dl>

                <tabs>
                    <tab title="Edit" v-if="!task.created_at || task.canEdit">
                        <fieldset>
                            <legend>Edit</legend>

                            <form @submit.prevent="saveTask" accept-charset="UTF-8" novalidate="novalidate"
                                  data-vv-scope="task">

                                <div class="row">
                                    <div class="col-sm-6 col-md-7 col-lg-8 form-group has-feedback"
                                         :class="{'has-error': errors.has('task.Task[project_id]')}">
                                         <dl v-if="!this.task.id && task.taskable_type_name !== null">
                                            <dt>{{task.taskable_type_name}}</dt>
                                            <dd>
                                                {{task.taskable_name}}
                                            </dd>
                                        </dl>

                                        <p v-if="this.task.id" style="color: red;"><i>Note: Navigating tabs may discard changes</i></p>

                                        <label for="task-project-id">Project</label>
                                        <select id="task-project-id"
                                                v-validate="this.task.id ? '' : 'required'"
                                                v-model="task.project_id"
                                                name="Task[project_id]"
                                                class="form-control">
                                            <option v-for="(property) in properties" :value="property.project_id">
                                                {{property.name}}
                                            </option>
                                        </select>

                                        <span v-show="errors.has('task.Task[project_id]')" class="help-block">
                                        {{ errors.first('task.Task[project_id]') }}
                                        </span>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-sm-6 col-md-7 col-lg-8 form-group has-feedback"
                                         :class="{'has-error': errors.has('task.Task[task_reason_code_id]')}">
                                        <label for="task-reason-code-id">Categorize Ticket</label>
                                        <select id="task-reason-code-id"
                                                v-validate="!this.task.id && this.task.reasonCodes.length === 0 ? 'required' : ''"
                                                v-model="taskReasonCode"
                                                name="Task[task_reason_code_id]"
                                                class="form-control"
                                                @change="onTaskReasonCodeSelect($event)">
                                            <option v-for="(reason) in reasonCodes.filter(code => code.deleted_at === null)" :value="reason.reason_code">
                                                {{reason.reason_message}}
                                            </option>
                                        </select>
                                        <br />
                                        <span v-if="task.reasonCodes.length === 0"><i>No Categorizations</i></span>
                                        <span v-for="(taskReasonCode, index) in task.reasonCodes">
                                            &nbsp;
                                            <b>{{ getTaskReasonMessage(taskReasonCode) }}</b>
                                            <a href="javascript://void" @click="removeTaskReasonCode(index)">
                                                &nbsp;<i class="fa fa-trash-o"></i>
                                            </a>
                                            <br />
                                        </span>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-sm-6 col-md-7 col-lg-8 form-group has-feedback"
                                         :class="{'has-error': errors.has('task.Task[title]')}">
                                        <label for="task-title">Title</label>
                                        <input id="task-title"
                                               v-validate="'required'"
                                               v-model="task.title"
                                               required="required"
                                               name="Task[title]"
                                               type="text"
                                               class="form-control"
                                               aria-required="true">

                                        <span v-show="errors.has('task.Task[title]')" class="help-block">
                                        {{ errors.first('task.Task[title]') }}
                                        </span>
                                    </div>
                                    <div class="col-sm-6 col-md-5 col-lg-4 form-group has-feedback"
                                         :class="{'has-error': errors.has('task.Task[due_at]')}">
                                        <label for="task-due-at">Due At</label>
                                        <input id="task-due-at"
                                               name="Task[due_at]"
                                               type="date"
                                               v-model="task.due_at"
                                               class="form-control">

                                        <span v-show="errors.has('task.Task[due_at]')" class="help-block">
                                            {{ errors.first('task.Task[due_at]') }}
                                        </span>
                                    </div>
                                </div>

                                <h5 class="markdown-hints text-right">
                                    <strong>*bold*</strong>&nbsp;<i>_italics_</i>&nbsp;<code>`code`</code>&nbsp;
                                    <pre>```preformated```</pre>
                                    &nbsp;&gt;quote
                                </h5>

                                <hr>

                                <div class="row">
                                    <div class="col-xs-6 form-group">
                                        <button type="button" class="btn btn-sm btn-warning"
                                                @click="deleteTask"
                                                v-if="task.id && task.deleted_at === null"
                                                :disabled="loading">
                                            <i class="fa fa-trash" aria-hidden="true"></i>
                                        </button>

                                        <button type="button" class="btn btn-sm btn-warning"
                                                @click="restoreTask"
                                                v-if="task.id && task.deleted_at"
                                                :disabled="loading">
                                            <i class="fa fa-refresh" aria-hidden="true"></i>
                                        </button>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-xs-6 form-group">
                                        <button
                                            type="button" class="btn btn-block btn-default"
                                            @click="resetTask"
                                            v-if="task.id"
                                            :disabled="!activeChangesExist"
                                            :class="{ 'dashboard-block-faded': !activeChangesExist }"
                                        >
                                            Discard Changes
                                        </button>
                                    </div>

                                    <div class="col-xs-6 form-group">
                                        <button
                                            type="submit"
                                            class="btn btn-block btn-success"
                                            :disabled="loading"
                                        >
                                            Save
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </fieldset>
                    </tab>

                    <tab title="Assign" v-if="task.created_at && task.canAdmin">
                        <fieldset>
                            <legend>
                                <button
                                    class="btn pull-left"
                                    :class="{ 'btn-success': !showAccess, 'btn-default': showAccess }"
                                    type="button"
                                    v-if="task && task.availableUsers"
                                    @click="showAccess = !showAccess">
                                    <span v-if="!showAccess">
                                        Add Member
                                    </span>
                                    <span v-else>
                                        Cancel
                                    </span>
                                </button>

                                Members
                            </legend>

                            <form @submit.prevent="saveAccess" accept-charset="UTF-8" novalidate="novalidate"
                                  data-vv-scope="access" v-if="showAccess">

                                <div class="form-group has-feedback"
                                     :class="{'has-error': errors.has('access.Access[user_id]')}">
                                    <label for="access-user-id">Ticket Member</label>

                                    <select id="access-user-id"
                                            name="Access[user_id]"
                                            class="form-control"
                                            required="required"
                                            v-model="access.user_id"
                                            v-validate="'required'"
                                            aria-required="true">
                                        <option value="">-</option>
                                        <option v-for="user in task.availableUsers" :value="user.id">
                                            {{user.fullName}} ({{user.email}})
                                        </option>
                                    </select>

                                    <span v-show="errors.has('access.Access[user_id]')" class="help-block">
                                        {{ errors.first('access.Access[user_id]') }}
                                    </span>
                                </div>

                                <div class="row">
                                    <div class="col-sm-6 col-md-4">
                                        <button type="submit" class="btn btn-success btn-block" :disabled="loading">
                                            Save
                                        </button>
                                    </div>
                                </div>
                            </form>

                            <ul v-else class="list-group form-group">
                                <li class="list-group-item">
                                    <h5 v-if="task.user">
                                        {{task.user.fullName}} <span class="label label-excellent">Owner</span>
                                    </h5>
                                    <h5 v-else>
                                        <span class="label label-excellent">System Generated</span>
                                    </h5>
                                </li>

                                <li class="list-group-item" v-for="access in task.accesses">
                                    <a class="btn btn-xs btn-warning pull-right" href="javascript://void(0)"
                                       @click="removeAccess(access)">
                                        Remove
                                    </a>

                                    <h5>{{access.user.fullName}} <span v-html="access.permissionLabel"></span></h5>
                                </li>
                            </ul>
                        </fieldset>
                    </tab>

                    <tab title="Labels" v-if="task.created_at && task.canAdmin">
                        <fieldset>
                            <legend>Labels</legend>

                            <label-type-toggle
                                labelable-type="App\Task"
                                :labelable-id="task.id"
                                :afterSave="afterLabelSave"
                            >
                            </label-type-toggle>
                        </fieldset>
                    </tab>

                    <tab title="History" v-if="task.created_at && task.canAdmin">
                        <audits
                            :auditable-id="task.id"
                            auditable-type="App\Task">
                        </audits>
                    </tab>
                    
                    <tab title="Notes" v-if="task.id">
                        <admin-notes noteable_type="App\Task" :noteable_id="task.id" :user_id="$root.user.id">
                        </admin-notes>
                    </tab>
                </tabs>
            </div>
        </modal>
    </div>
</template>

<script>
    import Audits from "./Audits";
    const pluralize = require( 'pluralize' );

    export default {
        components: { Audits },
        props: {
            modalId: {
                default(){
                    return Math.random().toString();
                },
                type: String
            },

            taskId: {
                type: String
            },

            taskableTypeName: {
                type: String
            },

            taskableType: {
                type: String
            },

            defaults: {
                default(){
                    return {};
                }
            },

            afterSave: {
                default(){
                    return function(){
                    };
                }
            }
        },

        created(){
            this.init();
        },

        data(){
            var result = {
                loading: false,
                showAccess: false,
                access: {
                    user_id: null,
                    permission: 2
                },
                accessible: {},
                properties: [],
                reasonCodes: [],
                completionCodes: [],
                taskReasonCode: null,

                task: {
                    status: 0,
                    title: null,
                    description: null,
                    taskable_type: null,
                    taskable_id: null,
                    taskable_type_name: null,
                    taskable_name: null,
                    completion_code_id: null,
                    reasonCodes: [],
                    user_id_completed_by: null,
                    project_id: null
                },

                initialLoadedTask: null,
            };

            return _.merge( result, this.defaults );
        },
        computed: {
            displayDueAt(){
                if( this.task.due_at ){
                    return moment.utc( this.task.due_at ).format( 'MMM, Do YYYY' );
                }

                return null;
            },

            overdue(){
                if( this.task.due_at && !this.task.completed ){
                    return moment.utc( this.task.due_at ).diff( moment.utc(), 'days' ) < 0;
                }

                return false;
            },

            activeChangesExist(){
                return this.task.id && JSON.stringify(this.task) !== JSON.stringify(this.initialLoadedTask);
            }
        },
        watch: {
            taskId(){
                this.$nextTick( () => {
                    this.init();
                } );
            },
        },
        methods: {
            init(){
                this.loading = true;
                var promise = Promise.resolve( {} );

                if( this.taskId ){
                    this.task.id = this.taskId;

                    promise.then( () => {
                        return this.loadTask();
                    } );
                }

                return promise
                    .then(() => {
                        this.loadReasonCodes();
                        this.loadCompletionCodes();
                        return this.loadProperties();
                    })
                    .catch( this.$root.handleErrors )
                    .finally( () => {
                        this.loading = false;
                    } );
            },

            resetTask() {
                this.task = JSON.parse(JSON.stringify(this.initialLoadedTask))
                this.errors.clear();
            },

            // Tasks
            loadTask(){
                var url = '/api/tasks/' + this.task.id + '?_load[]=user&_load[]=availableUsers';

                return axios.get( url )
                    .then( ( response ) => {
                        var task = response.data.Task;
                        this.$set( this, 'task', task );
                        this.initialLoadedTask = JSON.parse(JSON.stringify(task));
                    } );
            },

            loadProperties(){
                var url = '/api/properties?sort_by=name&sort_dir=asc&project_id=!null';

                return axios.get( url )
                    .then( (response) => {
                        this.$set( this, 'properties', response.data.Properties );
                    });
            },

            loadReasonCodes(){
                var url = '/api/tasks/reasonCodes';

                return axios.get( url )
                    .then( (response) => {
                        this.$set( this, 'reasonCodes', response.data );
                    });
            },

            loadCompletionCodes(){
                return axios.get('/api/tasks/completionCodes')
                    .then( (response) => {
                        this.$set( this, 'completionCodes', response.data );
                    });
            },

            saveTask(){
                var url = '/api/tasks';

                return this.$validator.validateAll( 'task' )
                    .then( ( valid ) => {
                        if( valid ){
                            var promise;

                            if( this.task.id ){
                                promise = axios.put( url + '/' + this.task.id, {
                                    Task: this.task
                                } );
                            }
                            else {
                                promise = axios.post( url, {
                                    Task: this.task
                                } )
                            }

                            promise.then( ( result ) => {
                                if( !this.task.id ){
                                    this.task = result.data.Task;
                                }

                                return this.loadTask();
                            } )
                                .then( () => {
                                    this.afterSave();

                                    this.$notify( {
                                        type: 'success',
                                        placement: 'top-left',
                                        title: 'Saved Ticket',
                                    } );

                                    this.loading = false;
                                } )
                                .catch( ( err ) => {
                                    return this.$root.handleErrors( err, 'task' );
                                } );
                        }
                    } );
            },

            deleteTask(){
                return axios.delete( '/api/tasks/' + this.task.id )
                    .then( () => {
                        this.afterSave();

                        this.$modal.hide( this.modalId );

                        this.$notify( {
                            type: 'success',
                            placement: 'top-left',
                            title: 'Archived Ticket',
                        } );

                        return this.init();
                    } )
                    .then( () => {
                        this.loading = false;
                    } )
                    .catch( ( err ) => {
                        this.$root.handleErrors( err, 'task' );
                    } );
            },

            restoreTask(){
                return axios.put( '/api/tasks/' + this.task.id + '/restore' )
                    .then( () => {
                        this.afterSave();

                        this.$notify( {
                            type: 'success',
                            placement: 'top-left',
                            title: 'Restored Ticket',
                        } );

                        return this.init();
                    } )
                    .then( () => {
                        this.loading = false;
                    } )
                    .catch( ( err ) => {
                        this.$root.handleErrors( err, 'task' );
                    } );
            },

            removeTaskReasonCode(index){
                this.task.reasonCodes.splice(index, 1)
            },

            getTaskReasonMessage(reasonCode){
                for (var code of this.reasonCodes) {
                    if (code.reason_code === reasonCode) {
                        return code.reason_message
                    }
                }

                return 'No reason message'
            },

            onTaskReasonCodeSelect(event){
                var code = parseInt(event.target.value);

                if (![null, '', NaN].includes(code) && !this.task.reasonCodes.includes(code))
                    this.task.reasonCodes.push(code)

                this.taskReasonCode = null;
            },

            toggleTaskCompleted(){
                var completed = this.task.completed_at === null;

                axios.put( '/api/tasks/' + this.task.id, {
                    'Task': {
                        'completed': completed,
                        'completion_code_id': completed ? this.task.completion_code_id : null
                    }
                } )
                    .then( () => {
                        this.afterSave();

                        this.$notify( {
                            type: (completed ? 'success' : 'warning'),
                            placement: 'top-left',
                            title: (completed ? 'Completed' : 'Un-completed') + ' Ticket',
                        } );

                        return this.init();
                    } )
                    .then( () => {
                        this.loading = false;
                    } )
                    .catch( ( err ) => {
                        this.$root.handleErrors( err, 'task' );
                    } );
            },

            saveAccess(){
                return this.$validator.validateAll( 'access' )
                    .then( ( valid ) => {
                        if( valid ){
                            this.loading = true;
                            this.access.accessible_id = this.task.id;
                            this.access.accessible_type = 'App\\Task';

                            axios.post( '/api/accesses', {
                                Access: this.access
                            } )
                                .then( ( result ) => {
                                    return this.loadTask();
                                } )
                                .then( () => {
                                    this.$notify( {
                                        type: 'success',
                                        placement: 'top-left',
                                        title: 'Added Member',
                                    } );
                                } )
                                .finally( () => {
                                    this.showAccess = false;
                                    this.loading = false;
                                } )
                                .catch( ( err ) => {
                                    return this.$root.handleErrors( err, 'access' );
                                } );
                        }
                    } );
            },


            claimTicket(){
                return this.$validator.validateAll( 'access' )
                    .then( ( valid ) => {
                        if( valid ){
                            this.loading = true;
                            this.access.accessible_id = this.task.id;
                            this.access.accessible_type = 'App\\Task';
                            this.access.user_id = null;

                            axios.post( '/api/accesses/claim', {
                                Access: this.access
                            } )
                                .then( ( result ) => {
                                    return this.loadTask();
                                } )
                                .then( () => {
                                    this.$notify( {
                                        type: 'success',
                                        placement: 'top-left',
                                        title: 'Added Member',
                                    } );
                                } )
                                .finally( () => {
                                    this.showAccess = false;
                                    this.loading = false;
                                } )
                                .catch( ( err ) => {
                                    return this.$root.handleErrors( err, 'access' );
                                } );
                        }
                    } );
            },

            removeAccess( access ){
                this.loading = true;

                axios.delete( '/api/accesses/' + access.id )
                    .then( ( result ) => {
                        return this.loadTask();
                    } )
                    .then( () => {
                        this.$notify( {
                            type: 'success',
                            placement: 'top-left',
                            title: 'Removed Ticket Member',
                        } );
                    } )
                    .finally( () => {
                        this.loading = false;
                    } )
                    .catch( this.$root.handleErrors );
            },

            afterLabelSave(){
                this.afterSave();
                return this.loadTask();
            },

            resetData(){
                Object.assign( this.$data, this.$options.data() );
                Object.assign( this.task, this.$options.propsData.defaults.task )
            },

            beforeClose(){
                this.$emit( 'before-close' );

                this.resetData();
            },

            openModal(){
                this.init()
                    .then( () => {
                        this.$modal.show( this.modalId );
                    } );
            },
        }
    }
</script>
